import React from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const TeamTab = ({ teamMembers, onCreateModal, onEditModal, onDelete }) => (
  <div data-testid="team-tab">
    <div className="flex justify-between items-center mb-6">
      <p className="text-s-text2">{teamMembers.length} team members</p>
      <Button onClick={() => onCreateModal('team')} className="bg-s-primary hover:bg-s-primary-h text-white" data-testid="add-team-btn">
        <Plus className="w-4 h-4 mr-2" /> Add Member
      </Button>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {teamMembers.map((member) => (
        <Card key={member.id} className="bg-s-bg2 border-s-border overflow-hidden" data-testid={`admin-team-card-${member.id}`}>
          <div className="aspect-[3/4] relative">
            <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
            <div className="absolute top-2 right-2">
              <Badge className="bg-black/60 text-white text-xs">#{member.order}</Badge>
            </div>
          </div>
          <CardContent className="p-4">
            <h3 className="text-s-text font-semibold text-sm">{member.name}</h3>
            <p className="text-s-primary text-xs mb-2">{member.role}</p>
            <p className="text-s-text2 text-xs line-clamp-2">{member.bio}</p>
            <div className="flex gap-2 mt-3">
              <Button size="sm" variant="outline" onClick={() => onEditModal('team', member)} className="flex-1 border-s-border text-s-text2">
                <Pencil className="w-4 h-4 mr-1" /> Edit
              </Button>
              <Button size="sm" variant="outline" onClick={() => onDelete('team', member.id)} className="border-red-500/50 text-s-primary hover:bg-s-primary/20">
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default TeamTab;
